module.exports = __webpack_public_path__ + "img/NFireShip64_ua.fc5135b5.webp";